import React from 'react';

import type { TDetection } from '@vlabs/shared/components/photo-upload-form';
import { Control, FaceSample, BodySample } from '@vlabs/uikit';

import st from './ReferenceSelector.module.sass';
import type { TDetections } from './useDetections';
import { useSearchPageTranslation } from '../../i18n';

interface ReferenceDetectionsListProps {
  detections: TDetections;
  selectedDetections: TDetection[];
  onSelectDetection: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function ReferenceDetectionsList({
  detections,
  selectedDetections,
  onSelectDetection,
}: ReferenceDetectionsListProps): React.JSX.Element {
  const { t } = useSearchPageTranslation();

  return (
    <React.Fragment>
      {detections.faces.length > 0 && (
        <div className={st.DetectionsWrapper}>
          <div className={st.DetectionsSubtitle}>
            {t('reference_selector.face_input.results.faces.title')}
          </div>
          <div className={st.DetectionsList}>
            {detections.faces.map((detection) => (
              <Control.SelectImage
                checked={selectedDetections.some((selectedDetection) => selectedDetection.id === detection.id)}
                image={(
                  <FaceSample
                    size="small"
                    src={detection.image}
                  />
                )}
                key={detection.id}
                onChange={onSelectDetection}
                value={detection.id}
              />
            ))}
          </div>
        </div>
      )}
      {detections.bodies.length > 0 && (
        <div className={st.DetectionsWrapper}>
          <div className={st.DetectionsSubtitle}>
            {t('reference_selector.face_input.results.bodies.title')}
          </div>
          <div className={st.DetectionsList}>
            {detections.bodies.map((detection) => (
              <Control.SelectImage
                checked={selectedDetections.some((selectedDetection) => selectedDetection.id === detection.id)}
                image={(
                  <BodySample
                    shape="rectangle"
                    size="small"
                    src={detection.image}
                  />
                )}
                key={detection.id}
                onChange={onSelectDetection}
                value={detection.id}
              />
            ))}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export { ReferenceDetectionsList };
